export enum VhostStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  TERMINATED = 'TERMINATED',
}

export const CDNVhostStatusStrings = {
  0: 'Active',
  1: 'Disabled',
  2: 'Terminated',
};

export interface ServerIp {
  id: number;
  serverIp: string;
  vhostId: number;
}

export interface CDNVhost {
  id: string;
  domain: string;
  websiteId: number;
  originServerHostname: string;
  ip: string;
  serverIps: ServerIp[];
  status: VhostStatus;
  hash: string;
  xdnEnabled: boolean;
  cdnEnabled?: boolean;
}

export interface CDNVhostCreate {
  domain: string;
  websiteId: number;
  originServerHostname: string;
  ip: string[];
  xdnEnabled: boolean;
}

export interface XDNFeatures {
  captcha: boolean;
  captchaLevel: boolean;
  qsIgnore: boolean;
  cacheReferer: string[];
  cacheBypass: boolean;
  uaList: string[];
  countryBan: string[];
  countryAction: 'allow' | 'ban' | '';
  countryHtAccess: boolean;
}
